import { Injectable } from '@angular/core';
import { OrganizationUnit } from '../misc/interface/organization-unit';
import { OrgUnitsService } from './org-units.service';
import { DataService } from './data.service';
import { PermissionLoaderService } from './permission-loader.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionHandlerService {
  private permissions: any = [];
  private parentOU = 'الجهات المشاركة';
  isLoggedIn: boolean = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  public content: string[] = [];
  public all: string[] = [];
  public payload: payloadType = {
    content: {
      allow: false,
      signedOus: { all: [], content: [] },
      allOus: { all: [], content: [] }
    },
    kLibrary: {
      allow: false,
      ou: [],
      categories: []
    },
    dataView: {
      allow: false,
      allowPrint: false,
      signedOus: [],
      allOus: []
    },
    templateHide: {
      fields: []
    }
  };

  constructor(
    private ouService: OrgUnitsService,
    private dataService: DataService,
    private permisssionLoader: PermissionLoaderService) { 

    this.loadFromLocalStorage();

    if (!this.isLoggedIn) {
      this.init();
    }
  }

  private loadFromLocalStorage() {
    let all = localStorage.getItem('all_ou');
    let content = localStorage.getItem('content_ou');
    let payload = localStorage.getItem('payload');

    if (all) {
      this.all = JSON.parse(all);
    }
    if (content) {
      this.content = JSON.parse(content);
    }
    if (payload) {
      this.payload = JSON.parse(payload);
    } else {
      // Initialize payload if not in localStorage
      this.payload = {
        content: {
          allow: false,
          signedOus: { all: [], content: [] },
          allOus: { all: [], content: [] }
        },
        kLibrary: {
          allow: false,
          ou: [],
          categories: []
        },
        dataView: {
          allow: false,
          allowPrint: false,
          signedOus: [],
          allOus: []
        },
        templateHide: {
          fields: []
        }
      };
    }
  }

  // Called from templates on every change detection; without a stored role there is nothing to load.
  private ensureInit() {
    if (this.permissions.length == 0 && localStorage.getItem('role')) {
      this.init();
    }
  }

  // Loads can overlap; "done" is announced once the last one finishes.
  private loadsInFlight = 0;

  async init() {
    this.loadsInFlight++;
    this.permisssionLoader.setState(true);
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      this.loadsInFlight--;
      if (this.loadsInFlight === 0) {
        this.permisssionLoader.setState(false);
      }
    };
    try {
      let roleStr = localStorage.getItem('role');
      if (roleStr) {
        let role = JSON.parse(roleStr);
        this.permissions = role.permissions;
        try {
          await Promise.all([this.initContentOuPermissionForLogin(), this.getData()]);
        } finally {
          finish();
        }
        await this.syncNotificationOusFromServer();
      } else {
        finish();
      }
    } catch (e) {
      finish();
      console.error('PermissionHandlerService.init failed', e);
    }
  }

  private notificationOusRequest: { owner: string; promise: Promise<void> } | null = null;

  /**
   * Caches role-derived OU ids for notification filtering (avoids trusting
   * over-broad `all_ou` from `ou/with/parent/child` for socket / client checks).
   * Fetched once per user; logout clears localStorage.
   */
  syncNotificationOusFromServer(): Promise<void> {
    if (this.cachedNotificationOus()) {
      return Promise.resolve();
    }
    const owner = this.notificationOusOwner();
    if (this.notificationOusRequest?.owner === owner) {
      return this.notificationOusRequest.promise;
    }
    const promise = this.fetchNotificationOus(owner).finally(() => {
      if (this.notificationOusRequest?.promise === promise) {
        this.notificationOusRequest = null;
      }
    });
    this.notificationOusRequest = { owner, promise };
    return promise;
  }

  cachedNotificationOus(): string[] | null {
    try {
      const cached = JSON.parse(localStorage.getItem('notif_ous') || 'null');
      return cached?.owner === this.notificationOusOwner() && Array.isArray(cached.ous) ? cached.ous : null;
    } catch {
      return null;
    }
  }

  private async fetchNotificationOus(owner: string): Promise<void> {
    try {
      const res = await this.dataService.getData('notification/effective-ou/getpiu');
      if (!res?.error && Array.isArray(res?.data)) {
        localStorage.setItem('notif_ous', JSON.stringify({ owner, ous: res.data }));
      }
    } catch {
      localStorage.removeItem('notif_ous');
    }
  }

  private notificationOusOwner(): string {
    return localStorage.getItem('isLoggedIn') == 'true' ? localStorage.getItem('uid') || '' : 'guest';
  }


  async getData() {
    // if (this.isLoggedIn) return Promise.resolve();
    let res = await this.dataService.getData('permission/investor-permission')
    if (res.error) return;
    let data = res.data;

    const [
      signedOusContent,
      allOusContent,
      ouKLibrary,
      signedOusDataView,
      allOusDataView
    ] = await Promise.all([
      this.getAllOus(data.content.signedOus, "SignedOus"),
      this.getAllOus(data.content.allOus, "All Ous"),
      this.getAllOus(data.kLibrary.ou, "K Library Ous"),
      this.getAllOus(data.dataView.signedOus, "SignedOus Dataview"),
      this.getAllOus(data.dataView.allOus, "All Ous")
    ]);

    this.payload = {
      content: {
        allow: data.content.allow,
        signedOus: signedOusContent,
        allOus: allOusContent
      },
      kLibrary: {
        allow: data.kLibrary.allow,
        ou: ouKLibrary.content,
        categories: data.kLibrary.categories
      },
      dataView: {
        allow: data.dataView.allow,
        allowPrint: data.dataView.allowPrint,
        signedOus: signedOusDataView.content,
        allOus: allOusDataView.content
      },
      templateHide: {
        fields: data.templateHide.fields
      }
    }
    console.log('FINAL FETCHED MAKE', this.payload)
    localStorage.setItem('payload', JSON.stringify(this.payload))
  }

  async getAllOus(ids: string[], clue?:string ): Promise<{ all: string[], content: string[] }> {
    if (ids.length > 0) {
      
      let all, content;
      let res = await this.dataService.postData('ou/with/parent/child', { ous: ids, clue: clue })
      if (!res.error && !!res.data && res.data.length > 0) {
        all = res.data[0].all;
        content = res.data[0].content
        return { all, content }
      }
    }
    return { all: [], content: [] }
  }

  async initContentOuPermissionForLogin() {
    let ou = await this.extractOUChildren('CONTENT', 'r');
    if (!!ou && ou.length > 0) {
      let ids;
      if (ou[0].label == this.parentOU) {
        ids = ou[0].children.map((e: any) => e._id)
      } else {
        ids = ou.map((e: any) => e._id)
      }

      let res = await this.dataService.postData('ou/with/parent/child', { ous: ids })
      if (!res.error && !!res.data && res.data.length > 0) {
        this.all = res.data[0].all;
        this.content = res.data[0].content
      }
      console.log('INIT OU PERMISSION 2', ids, res)
      if (this.all.length > 0 && this.content.length > 0) {
        localStorage.setItem('all_ou', JSON.stringify(this.all));
        localStorage.setItem('content_ou', JSON.stringify(this.content))
      }
    }
    console.log('INIT OU PERMISSION', ou, this.all, this.content);

  }

  hasPermission(unit: string, flag: string): boolean {
    let result: boolean = false;
    this.ensureInit();

    for (let pData of this.permissions) {
      //checking if parent is the unit
      for (let permission of pData.permissions) {
        if (permission.name == unit) {
          result = this.checkFlag(flag, permission.options);
          if (result) {
            break;
          }
        } else {
          if (permission.children && permission.children.length > 0) {
            let childPermission = permission.children.find(
              (child: any) => child.name == unit
            );
            if (childPermission) {
              result = this.checkFlag(flag, childPermission.options);
              if (result) {
                break;
              }
            }
          }
        }
      }
      if (result) {
        break;
      }
    }
    return result;
  }

  hasAnyPermission(p: Array<{ unit: string, flag: string }>) {
    return p.some(e => this.hasPermission(e.unit, e.flag));
  }

  private extractOU(unit: string, flag: string) {
    console.log("EDIT P", this.permissions);
    let ou: any[] = [];
    this.ensureInit();
    for (let pData of this.permissions) {
      for (let permission of pData.permissions) {
        //checking if parent is the unit
        if (permission.name == unit) {
          let result = this.checkFlag(flag, permission.options);
          if (result) {
            if (permission.ou && permission.ou != null) {
              ou.push(permission.ou);
            } else {
              ou.push(permission.ouLabel);
            }
            break;
          }
        } else {
          if (permission.children && permission.children.length > 0) {
            let childPermission = permission.children.find(
              (child: any) => child.name == unit
            );
            if (childPermission) {
              let result = this.checkFlag(flag, childPermission.options);
              if (result) {
                if (permission.ou && permission.ou != null) {
                  ou.push(permission.ou);
                } else {
                  ou.push(permission.ouLabel);
                }
                break;
              }
            }
          }
        }
      }
    }
    console.log('EDIT PERMISSION B', ou)
    return ou;
  }

  public extractTags(unit: string, flag: string) {
    let tags: any[] = [];
    this.ensureInit();
    for (let pData of this.permissions) {
      for (let permission of pData.permissions) {
        //checking if parent is the unit
        if (permission.name == unit) {
          let result = this.checkFlag(flag, permission.options);
          if (result) {
            if (permission.tag && permission.tag != null) {
              tags.push(...permission.tag);
            }
            break;
          }
        } else {
          if (permission.children && permission.children.length > 0) {
            let childPermission = permission.children.find(
              (child: any) => child.name == unit
            );
            if (childPermission) {
              let result = this.checkFlag(flag, childPermission.options);
              if (result) {
                if (childPermission.tag && childPermission.tag != null) {
                  tags.push(...childPermission.tag);
                }
                break;
              }
            }
          }
        }
      }
    }
    return tags;
  }

  private checkFlag(flag: any, options: any): boolean {
    if (options.type == 'RADIO') {
      return options.options.allow;
    } else if (options.type == 'CHECKBOX') {
      switch (flag) {
        case 'c':
          return options.options.write;
        case 'r':
          return options.options.read;
        case 'u':
          return options.options.update;
        case 'd':
          return options.options.delete;
      }
    }
    return false;
  }

  async extractOUChildrenWithInactive(unit: string, flag: string) {
    let permissionOUS = this.extractOU(unit, flag).filter(p => p != null && p != undefined);
    const treeData = await this.ouService.getOrgUnitsWithInactive();
    if (permissionOUS.includes('الجهات المشاركة')) {
      return treeData;
    }
    let ouChildren: any[] = [];
    for (let permissionOU of permissionOUS) {
      ouChildren.push(this.ouService.extractOUChildren(treeData, permissionOU));
    }
    return ouChildren;
  }

  async extractOUChildren(unit: string, flag: string) {
    let permissionOUS = this.extractOU(unit, flag).filter(p => p != null && p != undefined);
    const treeData = await this.ouService.getLatesOrgs();
    if (permissionOUS.includes('الجهات المشاركة')) {
      return treeData;
    }
    let ouChildren: any[] = [];
    for (let permissionOU of permissionOUS) {
      ouChildren.push(this.ouService.extractOUChildren(treeData, permissionOU));
    }
    return ouChildren;
  }

  async extractOUChildrenFromData(unit: string, flag: string, treeData: any) {
    let permissionOUS = this.extractOU(unit, flag).filter(p => p != null && p != undefined);
    if (permissionOUS.includes('الجهات المشاركة')) {
      return treeData;
    }
    let ouChildren: any[] = [];
    for (let permissionOU of permissionOUS) {
      ouChildren.push(this.ouService.extractOUChildren(treeData, permissionOU));
    }
    return ouChildren;
  }

  async checkOUPermission(unit: string, flag: string, label: string): Promise<boolean> {
    let ouChildren = await this.extractOUChildren(unit, flag);
    return this.ouService.childrenContains(ouChildren, label);
  }

  async checkOUPermissionByID(unit: string, flag: string, id: string): Promise<boolean> {
    let ouChildren = await this.extractOUChildren(unit, flag);
    return this.ouService.childrenContainsId(ouChildren, id);
  }

  checkOUPermissionByIDWithOus(id: string, children: any): boolean {
    return this.ouService.childrenContainsId(children, id);
  }

  checkOUPermissionByLabelWithOus(label: string, children: any): boolean {
    return this.ouService.childrenContains(children, label);
  }
}


interface payloadType {
  content: {
    allow: boolean,
    signedOus: { all: string[], content: string[] },
    allOus: { all: string[], content: string[] }
  },
  kLibrary: {
    allow: boolean,
    ou: string[],
    categories: string[]
  },
  dataView: {
    allow: boolean,
    allowPrint: boolean,
    signedOus: string[],
    allOus: string[]
  },
  templateHide: {
    fields: string[]
  }
}